<template>
  <div class="page">
    <!-- <div class="top" @click="back()">
      <p>
        <img src="https://img.yzcdn.cn/upload_files/2020/04/03/Fu1OESUm3NJYRRgDhqk7Ar6Yh-No.png" />
        返回
      </p>
    </div> -->
    <!-- <div class="mb21"></div> -->
    <banner-top title="" />
    <div class="main">
      <div class="book_detail">
        <div class="book_img">
          <img
            :src="
              catalogueData.book.thumbCoverPath
                ? $env.ossUrl(catalogueData.book.thumbCoverPath)
                : ''
            "
          />
        </div>
        <div class="book_title flex-col">
          <div>
            <h3 v-if="catalogueData.book.category">
              {{ catalogueData.book.renderTagName }}
            </h3>
            <div class="book_sub_title_one flex-row">
              <div class="book_sub_title_course book_sub_title_pub">
                {{ catalogueData.book.courseName }}
              </div>
              <div v-if="catalogueData.book" class="book_sub_title_gc book_sub_title_pub">
                {{ catalogueData.book.gradesName }}{{ catalogueData.book.renderVolumeName }}
              </div>
            </div>
          </div>
          <div v-if="catalogueData.book.category === 'kebendiandu'" class="book_sub_title_two">
            <div class="book_sub_title_version">{{ catalogueData.book.versionName }}</div>
          </div>
        </div>
        <shujia :book-info="catalogueData" />
      </div>
      <!-- 正常目录部分 -->
      <div>
        <div v-for="(item, indexs) in chaptersData" :key="indexs" class="catalogue">
          <p class="catalogue_title">{{ item.title }}</p>
          <div
            v-for="(page, index) in item.pages"
            :key="index"
            class="catalogue_number"
            @click="toAnswerPage(item, page, index)"
          >
            <span
              :class="{
                noright: (index + 1) % 6 == 0,
                border_red: pageIdList.join(',').indexOf(page.id) >= 0
              }"
            >
              {{ page.pageName }}
              <!-- 会员角标 第十一页开始-->
              <img
                v-if="!vip && page.index + 1 > rights()"
                class="svip_icon"
                src="https://img01.yzcdn.cn/upload_files/2021/04/27/Fjdv4wnMx0mXYl62ZK4SQcGhaysO.png"
              />
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- bottom部分 -->
    <bottom v-if="isShowBottom" />

    <div v-if="BottomTengImgList" class="byOneself_AD">
      <div :class="externalOrg === 0 ? '' : 'outerAd'">
        <img :src="BottomTengImg" class="byOneself_AD-img" @click="byOneselfLink" />
        <img
          src="https://img.yzcdn.cn/upload_files/2020/11/09/Fv3ZJ0-xeUo3Tld3TBnER9nvdNT-.png"
          class="byOneself_AD-close"
          @click="BottomTengImgList = false"
        />
      </div>
    </div>
    <div class="TCAD_WRAP">
      <div id="TCAD_pageDDNum" class="TCAD_pageDDNum"></div>
    </div>
    <!--
      <TcadTenWarp
      v-if="!vip"
      :c-codes="'textBookBottom'"
      :containerid="'TCAD_pageDDNum'"
      :tcad-heiht="'2.1rem'"
    />
    -->
  </div>
</template>

<script>
import { Col, Row, Toast, Overlay } from 'vant'
import BannerTop from '@/components/BannerTop'
import bottom from '../../component/bottom2'
import shujia from '../../component/shujia'
import { format, getCookie, setCookie, uniqueArr, changeDocTitle } from '@/static/js/zjs.js'
import { hideTCAD, renderTCAD } from '@/plugin/TCAD'
import { getMopaAd } from '@/api/ad'
import { mapState } from 'vuex'
import { transformOssbookDictionary } from '@/static/js/business'

export default {
  name: '',
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Toast.name]: Toast,
    [Overlay.name]: Overlay,
    BannerTop,
    bottom,
    shujia
  },
  data() {
    return {
      loaded: false,
      catalogueData: {
        book: {}
      }, // 课本源数据
      chaptersData: [], // 章节源数据
      title: '', // doc的title
      workbook_id: '', // 书的id
      openid: '',
      pageIdList: [], // 用来框红框
      BottomTengImg: '', // 新增页码页底部广告图片
      BottomTengImglink: '', // 新增页码页底部广告图片跳转链接
      BottomTengImgList: false,
      externalOrg: null,
      num2txt: {
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
        6: '六',
        7: '七',
        8: '八',
        9: '九'
      }
    }
  },
  computed: {
    ...mapState('dictionary', ['answerVersion', 'mj_course']),
    userInfo() {
      return this.$store.userInfo
    },
    vip() {
      // 会员 买过点读模块
      return (
        this.$store.state.user.userInfo.vipLevel !== 'nv' ||
        this.$store.state.user.userInfo.isRead === 'Y'
      )
    },
    isShowBottom() {
      return this.loaded && !this.vip
    }
  },
  created() {
    this.workbook_id = this.$route.query.id
    this.openid = this.$store.openid
  },
  async mounted() {
    this.getBookPageJosn(this.workbook_id)
    if (getCookie('dataList' + this.workbook_id)) {
      this.pageIdList = getCookie('dataList' + this.workbook_id).split(',')
    } else {
      this.pageIdList = []
    }
    this.$pop.next()
    //  广告加载，变换样式
    // if (!this.vip) {
    //   this.$nextTick(() => {
    //     renderTCAD({
    //       containerid: 'TCAD_pageDDNum',
    //       index: 0,
    //       success(ad) {
    //         ad.style.bottom = '2.1rem'
    //       }
    //     })
    //   })
    // }
    await this.textBookAd()
  },
  beforeDestroy() {
    hideTCAD(0)
  },
  methods: {
    format,
    changeDocTitle,
    // 格式化学科名称
    initCourseName(value) {
      try {
        const a = this.mj_course.find((i) => +i.value === value).chName
        return a
      } catch (e) {
        return ''
      }
    },
    // 返回
    rights() {
      const category = this.catalogueData.book.category
      if (category === 'huibendiandu') {
        return 0
      } else if (category === 'kebendiandu') {
        return 10
      } else if (category === 'mingzhuyuedu') {
        return 1
      }
    },
    back() {
      this.$router.back()
    },
    textBookAd() {
      return getMopaAd(
        {
          code: 'answerPage', // 页面
          cCodes: 'textBookBottom' // 页面位置
        },
        this.$store.userInfo.vipLevel.toUpperCase(),
        this.$env.isIos
      )
        .then((res) => {
          if (!this.vip && res.length === 0) {
            this.$nextTick(() => {
              // renderTCAD({
              //   containerid: 'TCAD_pageDDNum',
              //   index: 0,
              //   success(ad) {
              //     ad.style.bottom = '2.1rem'
              //   }
              // })
            })
          }
          if (res && res.length > 0 && !this.vip) {
            // 随机展示每一项
            this.BottomTengImgList = true
            var Manthimg = Math.floor(Math.random() * res.length)
            this.BottomTengImg = res[Manthimg].imgPath
            this.BottomTengImglink = res[Manthimg].urlPath
            this.externalOrg = res[Manthimg].externalOrg
          }
        })
        .catch((error) => {
          if (error.response.status === 403 && !this.vip) {
            this.$nextTick(() => {
              // renderTCAD({
              //   containerid: 'TCAD_pageDDNum',
              //   index: 0,
              //   success(ad) {
              //     ad.style.bottom = '2.1rem'
              //   }
              // })
            })
          }
        })
    },
    byOneselfLink() {
      this.$trackevent({
        type: 'funcTracker',
        action: 'click',
        opt_label: '点读页下方广告'
      })
      if (this.BottomTengImglink) {
        location.href = this.BottomTengImglink
      }
    },
    // 点击页码操作
    toAnswerPage(item, page, index) {
      this.pageIdList.push(page.id) // 看过的页码标红
      setCookie('dataList' + this.workbook_id, uniqueArr(this.pageIdList), 1)
      this.$router.push({
        path: 'dianDuPage',
        query: {
          workbook_id: this.workbook_id,
          chapter: item.id,
          pageId: page.id,
          name: this.$route.query.name
        }
      })
    },
    // 获取页码页数据json
    getBookPageJosn(workbook_id) {
      this.$store.dispatch('dianDuRight/getBookData', { workbookId: workbook_id }).then((res) => {
        transformOssbookDictionary(res.data).then(() => {
          this.catalogueData = res.data
          this.chaptersData = res.data.book.chapters
          this.changeDocTitle(this.catalogueData.book.name || this.catalogueData.book.abbrName)
          this.testTongji()
          this.loaded = true
        })
      })
    },
    // 会员免费
    toVip() {
      this.$trackevent({
        type: 'funcTracker',
        action: 'click',
        opt_label: '点读-会员免费_clcik'
      })
      window.location.href = '/cms/webapp/home/vipPay/index.html?channel=svip_dd_ymy_gn'
    },
    // 相关课程
    related() {
      this.$trackevent({
        type: 'funcTracker',
        action: 'click',
        opt_label: '点读-相关课程_clcik'
      })
      //  https://weixin.zijinshe.com/cms/static/hwVideoHtml/relative_video.html?wbId=6373&v=1&vers=&grade=0&volume=0&course=3
      window.location.href = `/cms/static/hwVideoHtml/relative_video.html?wbId=${this.workbook_id}&v=1&grade=0&volume=0&course=${this.catalogueData.book.course}`
    },
    // 统计
    testTongji() {
      if (window.Statistic) {
        const {
          openid,
          userInfo: { vipLevel, wbGrade, isRead, isCourse }
        } = this.$store

        var category = this.catalogueData.book.category
        if (category === 'huibendiandu') {
          var wbType = 6
        } else if (category === 'kebendiandu') {
          wbType = 5
        } else if (category === 'mingzhuyuedu') {
          wbType = 13
        }
        window.Statistic.trackEvent({
          app: 'shanxiCms',
          source: 'mopa',
          openid: openid,
          category: '1',
          action: 'view',
          label: '页码页',
          vip: vipLevel || '',
          label1: this.workbook_id,
          wbType: wbType,
          userGrade: wbGrade,
          userType: (isRead || '') + ':' + (isCourse || '')
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.TCAD_pageDDNum {
  bottom: 1.4rem;
}
.outerAd {
  position: relative;
}
.outerAd::before {
  content: '广告';
  width: 29px;
  height: 16px;
  line-height: normal;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 11;
  left: 0px;
  top: 0px;
  font-family: PingFangSC, Sans-serif, -apple-system, Arial, sans-serif !important;
  font-size: 10px !important;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  color: #ffffff;
}
.byOneself_AD {
  position: fixed;
  left: 0;
  bottom: 1.36rem;
  .byOneself_AD-img {
    width: 100vw;
    height: 56px;
  }
  .byOneself_AD-close {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 4px;
    top: 4px;
  }
}
.page {
  width: 100%;
  background: rgba(255, 255, 255, 1);
  min-height: 100%;
  overflow: auto;
  border-top: 0.5px solid #f5f5f5;
  // 间隔0.21rem
  .mb21 {
    width: 100%;
    height: 0.21rem;
    background: rgba(249, 249, 249, 1);
  }
  .top {
    width: 100%;
    height: 1.2rem;
    display: flex;
    align-items: center;
    p {
      display: inline-block;
      width: 1.48rem;
      font-size: 0.32rem;
      line-height: 0.77rem;
      color: rgba(51, 51, 51, 1);
      background: url('https://img.yzcdn.cn/upload_files/2020/04/03/FjdPBims__fR87pn2l24J7e1yWiT.png')
        no-repeat;
      background-size: 1.48rem 0.77rem;
      margin-left: -2px;
      img {
        display: inline-block;
        width: 0.19rem;
        height: 0.33rem;
        margin-left: 0.2rem;
        margin-right: 0.11rem;
        position: relative;
        top: 1px;
      }
    }
  }
  .main {
    padding: 0.72rem 0.4rem 0.4rem;
    margin-bottom: 1.36rem;
    .book_detail {
      width: 9.2rem;
      height: 3.39rem;
      position: relative;
      background: rgba(255, 255, 255, 1);
      border-radius: 0.11rem;
      box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.06);

      .book_img {
        float: left;
        .mask {
          width: 2.45rem;
          height: 3.39rem;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-content: center;
          align-items: center;
          justify-content: center;
          position: absolute;
          left: 0.32rem;
          top: -0.32rem;
          right: 0.36rem;
          border-radius: 0.07rem;
          .mask_img {
            width: 0.48rem;
            height: 0.49rem;
            position: relative;
          }
          .name {
            font-size: 0.27rem;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            line-height: 0.36rem;
            margin-top: -0.13rem;
          }
        }
        .img,
        img {
          width: 2.45rem;
          height: 3.39rem;
          position: absolute;
          left: 0.32rem;
          top: -0.32rem;
          right: 0.36rem;
          border-radius: 5px;
          // border: 1px solid rgba(237, 237, 237, 1);
          box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
        }
      }
      .book_title {
        float: right;
        width: calc(100% - 3.24rem);
        height: 100%;
        margin-top: 0.31rem;
        .book_sub_title_one {
          font-size: 10px;
          color: #ff8126;
        }
        .book_sub_title_two {
          font-size: 12px;
          display: flex;
          height: 26px;
          position: absolute;
          bottom: 0.32rem;
          margin-top: 26px;
          align-items: center;
          color: #808080;
        }
        .book_sub_title_version {
        }
        .book_sub_title_pub {
          margin-top: 10px;
          padding: 2px 4px;
          background: rgba(255, 129, 38, 0.1);
        }
        .book_sub_title_gc {
          margin-left: 6px;
        }
        h3 {
          font-size: 0.4rem;
          color: #333333;
          line-height: 0.55rem;
          margin-right: 0.68rem;
          height: 39px;
          display: -webkit-box;
          overflow: hidden;
          white-space: normal !important;
          text-overflow: ellipsis;
          word-wrap: break-word;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        p {
          color: #b2b2b2;
          font-size: 0.32rem;
          margin-right: 0.68rem;
          line-height: 0.45rem;
          display: -webkit-box;
          overflow: hidden;
          white-space: normal !important;
          text-overflow: ellipsis;
          word-wrap: break-word;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
      }
    }
    .catalogue {
      .catalogue_title {
        font-size: 0.43rem;
        font-weight: 400;
        color: #333333;
        line-height: 0.36rem;
        margin-bottom: 0.53rem;
        padding-top: 0.85rem;
      }
      .catalogue_number {
        display: inline-block;
        color: #333333;

        .noright {
          margin-right: 0;
        }
        span {
          display: inline-block;
          position: relative;
          width: 1.28rem;
          height: 1.28rem;
          background: #f5f5f9;
          border-radius: 0.13rem;
          font-size: 0.37rem;
          text-align: center;
          line-height: 1.28rem;
          margin-right: 0.29rem;
          margin-bottom: 0.36rem;
          &.border_red {
            background: rgba(255, 237, 239, 1);
            border: 1px solid rgba(255, 54, 71, 1);
            color: rgba(255, 54, 71, 1);
          }
          .svip_icon {
            width: 23px;
            position: absolute;
            top: 0;
            right: 0;
          }
        }
      }
    }
  }
}
</style>
